export { M40PromotedContent } from './M40PromotedContent';
export { M40PromotedContent as default } from './M40PromotedContent';
